import React, { useEffect, useState } from "react";

const CharCount = ({ value, maxLength }) => {
  const [charCount, setCharCount] = useState(0);

  useEffect(() => {
    setCharCount(value ? value.length : 0);
  }, [value]);

  return <span className="text-additional">{charCount} / {maxLength}</span>;
};

export default CharCount;
